import request from '@/utils/request.js'

export function liveList() {
  return request({
    url: '/live/list',
    method: 'get',
  })
}
